import { render, staticRenderFns } from "./DepartamentoLocalLeitorMonitoramentoArmazenamentoForm.vue?vue&type=template&id=2f1f8875"
import script from "./DepartamentoLocalLeitorMonitoramentoArmazenamentoForm.vue?vue&type=script&lang=js"
export * from "./DepartamentoLocalLeitorMonitoramentoArmazenamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports